import { Component, OnInit, NgZone, ViewChild, AfterViewInit } from '@angular/core';
import { DataService } from '../shared/services/dataService';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { of } from 'rxjs';
import { InterviewDocument } from 'app/shared/services/interviewDetailsService';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService, BannerNotification } from 'app/shared/services/notificationService';
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';
import { CommentService } from 'app/shared/services/commentService';
import { CaseService } from '../shared/services/caseService';
import { GetPastDueBannerText } from '../shared/pipes/pastDueBannerTextPipe';
import { Case, SearchCase, CaseByPageModel, CaseFilter } from 'app/shared/models/caseModel';
import { BaseComponent } from 'app/shared/baseClasses/BaseComponent';
import { EventTypes, StorageConstants } from 'app/shared/utility/constants';
import { UIStateService } from 'app/shared/services/uiStateService';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends BaseComponent implements OnInit, AfterViewInit {
  showReport: boolean;
  showCensus: boolean;
  public OpenObserve: Observable<Array<any>>;
  public AvailableObserve: Observable<Array<any>>;
  public SubmittedObserve: Observable<Array<any>>;
  public DismissedObserve: Observable<Array<any>>;
  public currentOpenCaseCount: number = 0;
  public currentAvailableCaseCount: number = 0;
  public currentDismissedCaseCount: number = 0;
  public currentSubmittedCaseCount: number = 0;
  public pageSizeOpen: number = 100;
  public pageSizeAvailable: number = 100;
  public pageSizeSubmitted: number = 100;
  public pageSizeDismissed: number = 100;
  public resources: Array<any> = [];
  public isAdmin: boolean = false;
  public status: string;
  public caseId: string;
  public caseDetails: Case;
  public filterLabel: string = 'Filter';
  public filterIcon: string = 'filter_list'
  public showFilter: boolean = false;
  public loading = { open: false, available: false, submitted: false, dismissed: false }
  public openCaseOverDueCount: number = 0;
  public avaliableCaseOverDueCount: number = 0;
  public submittedCaseOverDueCount: number = 0;
  public dismissedCaseOverDueCount: number = 0;

  public bannerNotificationDismissed: boolean;
  public bannerNotification: BannerNotification;
  public commentThreadInfos: any;
  public displayPositiveOnly = true;
  public filterDisplayText = "";
  public bannerRefreshJob: any = null;

  public options = {
    id: 2,
    timeOut: 4 * 1000,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 7,
    showProgressBar: false,
    pauseOnHover: true,
    preventDuplicates: false,
    preventLastDuplicates: 'visible',
    rtl: false,
    animate: 'scale',
    position: ['right', 'bottom']
  };

  columnSortState: { [key: string]: boolean | null } = {
    'Ocme': null,
    'ResidentJurisdiction': null,
    'DateofDeath': null,
    'CauseofDeath': null,
    'CountyofDeath': null,
    'HasFiles': null,
    'IsNonFatal': null
  };

  columnToName: { [key: string]: string } = {
    'Ocme': 'OCME / MIEMSS#',
    'ResidentJurisdiction': 'Resident County',
    'DateofDeath': 'Date of Death / Incident',
    'CauseofDeath': 'Cause of Death',
    'CountyofDeath': 'Incident County',
    'HasFiles': 'Has Files',
    'IsNonFatal': 'Non-Fatal'
  }

  searchFieldToName: { [key: string]: string } = {
    'Fatal': 'Fatal',
    'NonFatal': 'Non-Fatal',
    'dateOfDeathFrom': 'Date of Death / Incident From',
    'dateOfDeathTo': 'Date of Death / Incident To',
    'dateOfBirthFrom': 'Date of Birth From',
    'dateOfBirthTo': 'Date of Birth To',
    'flaggedOnly': 'Show Flagged',
    'incidentCounty': 'Incident County',
    'lastName': 'Last Name',
    'ocme': 'OCME / MIEMSS #',
    'residentCounty': 'Resident County',
    'hasUnresolvedMessages': 'Unresolved Messages',
    'hasUnreadMessages': 'Unread Messages',
    'isArchived': 'Archived Cases'
  }


  @ViewChild('tabGroup') tabGroup;
  @ViewChild('availableCasesPaginator') availableCasesPaginator: MatPaginator;
  @ViewChild('openCasesPaginator') openCasesPaginator: MatPaginator;
  @ViewChild('submittedCasesPaginator') submittedCasesPaginator: MatPaginator;
  @ViewChild('dismissedCasesPaginator') dismissedCasesPaginator: MatPaginator;

  constructor(
    protected uiStateService: UIStateService,
    private dataService: DataService,
    private notificationService: NotificationService,
    private commentService: CommentService,
    private caseService: CaseService,
    private config: AppConfig,
    private zone: NgZone,
    private snackBar: MatSnackBar
  ) {
    super(config);
    this.showReport = false;
    this.showCensus = false;
    this.status = 'loading';
  }

  ngOnInit() {
    if (sessionStorage.getItem(StorageConstants.DashboardInit) == null || sessionStorage.getItem(StorageConstants.DashboardInit) == 'false') {
      // reset dashboard state
      this.resetDashboard();
      sessionStorage.setItem(StorageConstants.DashboardInit, 'true');
    }

    let instance: DashboardComponent = this;
    instance.dataService.getAccess().subscribe((access) => {
      this.isAdmin = access.IsAdmin;

      instance.pageSizeOpen = Number(
        instance.config.getConfig('pageSizeAssigned')
      );
      instance.pageSizeAvailable = Number(
        instance.config.getConfig('pageSizeAvailable')
      );
      instance.pageSizeSubmitted = Number(
        instance.config.getConfig('pageSizeSubmitted')
      );
      instance.pageSizeDismissed = Number(
        instance.config.getConfig('pageSizeDismissed')
      );

      const searchCase = this.uiStateService.dashboardUI.SearchCase;

      if (this.uiStateService.dashboardUI.SearchCase.sortByProperty) {
        searchCase.isAscending = !searchCase.isAscending;
        this.sortByColumn(searchCase.sortByProperty);
      }

      this.filterDisplayText = this.displaySearchCaseProperties(this.uiStateService.dashboardUI.SearchCase);
      this.queryAll();

      instance.status = 'active';
    });

    this.subscribeEvent(EventList.dashboardClick, event => {
      if (event == true) {
        this.resetDashboard();
      }
    });

    this.subscribeEvent(EventList.refreshCommentThreadInfos, event => {
      this.onCaseCommentThreadClosed();
    });

    this.subscribeEvent(EventList.refreshDashboard, event => {
      this.queryAll(true);
    });

    this.getBannerNotification();

    this.bannerRefreshJob = setInterval(() => {
      this.getBannerNotification();
    }, 10000);
  }

  ngOnDestroy() {
    clearInterval(this.bannerRefreshJob);
  }

  getBannerNotification() {
    this.notificationService.GetLatestNotification().then(notifications => {
      if (notifications.length > 0) {
        this.bannerNotification = notifications[0];
      } else {
        this.bannerNotification = new BannerNotification();
        this.bannerNotification.Message = "";
      }

      this.bannerNotificationDismissed = this.bannerNotification.Message === "";
    });
  }

  resetDashboard(): void {
    if (this.tabGroup?.selectedIndex) {
      this.tabGroup.selectedIndex = 0;
    }
    this.uiStateService.dashboardUI.SelectedCasesTabIndex = 0;
    this.clearFilter(true);
  }

  ngAfterViewInit(): void {
    this.tabGroup.selectedIndex = this.uiStateService.dashboardUI.SelectedCasesTabIndex;

    this.availableCasesPaginator._intl.nextPageLabel = '';
    this.availableCasesPaginator._intl.lastPageLabel = '';

    this.openCasesPaginator._intl.nextPageLabel = '';
    this.openCasesPaginator._intl.lastPageLabel = '';

    this.submittedCasesPaginator._intl.nextPageLabel = '';
    this.submittedCasesPaginator._intl.lastPageLabel = '';

    this.dismissedCasesPaginator._intl.nextPageLabel = '';
    this.dismissedCasesPaginator._intl.lastPageLabel = '';
  }

  setCasesTabIndex(tabIndex: number) {
    this.uiStateService.dashboardUI.SelectedCasesTabIndex = tabIndex;
  }

  dismissNotification() {
    this.notificationService.DismissBannerNotification(this.bannerNotification.id).then(res => {
      this.bannerNotificationDismissed = true;
      EventAggregator.publish(EventList.bannerListRefresh, true);
      this.getBannerNotification();
    });
  }

  search($event) {
    this.uiStateService.dashboardUI.ShowClearFilter = false;

    const searchCase = this.uiStateService.dashboardUI.SearchCase;
    // tslint:disable-next-line:forin
    for (let key in searchCase) {
      if (this.uiStateService.dashboardUI.SearchCase[key]) {
        this.uiStateService.dashboardUI.ShowClearFilter = true;
        this.filterDisplayText = this.displaySearchCaseProperties(this.uiStateService.dashboardUI.SearchCase);
        break;
      }
    }
    this.queryAll(true);
  }

  queryAll(refresh: boolean = false) {
    this.commentService.GetCommentThreadInfos().then(res => {
      this.commentThreadInfos = res;

      let startPageNum: number | null = null;

      if (refresh) startPageNum = 1;

      this.paginationOpenCasesData(startPageNum);
      this.paginationAvailableCasesData(startPageNum);
      this.paginationDismissedData(startPageNum);
      this.paginationSubmittedData(startPageNum);
    });
  }

  getCaseHasComments(item) {
    const info = this.commentThreadInfos.find(i => i.CaseId == item.id && i.Ocme == item.OCME);
    if (!info) return false;

    return info.HasComments;
  }

  threadContainsUnread(item): boolean {
    const info = this.commentThreadInfos.find(i => i.CaseId == item.id && i.Ocme == item.OCME);
    if (!info) return false;

    return info.HasUnreadComments;
  }

  getCaseChatTitle(item): string {
    const info = this.commentThreadInfos.find(i => i.CaseId == item.id && i.Ocme == item.OCME);


    if (this.isAdmin) {
      if (!info || !this.getCaseHasComments(item)) return 'Add Messages';
      return info.IsThreadResolved ? 'Open Resolved Messages' : 'Open Unresolved Messages';
    } else {
      if (!info) return 'Message MDH';
      return (info.HasComments && info.HasUnreadComments) ? 'Open Unread Messages' : (info.HasComments && !info.HasUnreadComments) ? 'Open Read Messages' : 'Message MDH';
    }
  }

  getDeathIncidentFieldValue(item): string {
    if (item.DateofDeath) return item.DateofDeath;

    return item.DateofIncident;
  }

  getIsThreadResolved(item): boolean {
    const info = this.commentThreadInfos.find(i => i.CaseId == item.id && i.Ocme == item.OCME);

    if (!info) return false;

    return info.IsThreadResolved;
  }

  openDialog(event: any, id) {
    // show the 'please wait' popup
    this.caseId = id;
    this.caseService.getCaseInformation(this.caseId).then(resp => {
      this.showDetails(resp);
    }).catch(error => console.error(error));
  }

  onChatClicked(item: any) {
    EventAggregator.publish(EventList.popupTriggered, {
      type: EventTypes.CaseCommentThread,
      value: {
        caseId: item.id,
        ocme: item.OCME
      }
    });
  }

  public onCaseCommentThreadClosed() {
    this.commentService.GetCommentThreadInfos().then(res => {
      this.commentThreadInfos = res;
    });
  }

  showDetails(caseData: Case) {
    this.caseDetails = caseData;
    EventAggregator.publish(EventList.popupTriggered, {
      type: EventTypes.CaseDetails,
      value: {
        caseDetails: this.caseDetails,
        printMode: false
      }
    });
  }

  fileChange(event) {
    let confirmationString = 'Confirm that you intend to upload files:\n';
    for (let file of event.target.files) {
      confirmationString = confirmationString + file.name + '\n';
    }

    if (confirm(confirmationString) === true) {
      this.dataService.uploadFiles(event.target.files);
    }
  }

  onToggleFilter(): void {
    this.showFilter = !this.showFilter;
    if (this.showFilter) {
      this.filterLabel = 'Hide Filter';
      this.filterIcon = 'close'
      this.showCensus = false;
      this.showReport = false;
    } else {
      this.filterLabel = 'Filter';
      this.filterIcon = 'filter_list'

    }
  }

  clearFilter(hardReset: boolean = false) {
    const searchCase = this.uiStateService.dashboardUI.SearchCase;
    const sortByProperty = hardReset ? 'DateofDeath' : searchCase.sortByProperty;
    const isAsc = hardReset ? false : searchCase.isAscending;

    this.uiStateService.dashboardUI.SearchCase = new SearchCase();
    this.uiStateService.dashboardUI.SearchCase.sortByProperty = sortByProperty;
    this.uiStateService.dashboardUI.SearchCase.isAscending = isAsc;
    this.uiStateService.dashboardUI.ShowClearFilter = false;
    this.filterDisplayText = "";

    this.queryAll(true);
  }

  sortByColumn(sortByProp) {
    const searchCase = this.uiStateService.dashboardUI.SearchCase;
    const isAsc = (searchCase.sortByProperty !== sortByProp) || !searchCase.isAscending;

    this.columnSortState[searchCase.sortByProperty] = null;
    this.columnSortState[sortByProp] = isAsc;

    this.uiStateService.dashboardUI.SearchCase.isAscending = isAsc;
    this.uiStateService.dashboardUI.SearchCase.sortByProperty = sortByProp;

    this.queryAll();
  }

  StatusChangeNotification(): any {
    this.snackBar.open('Status Successfully Changed', 'close', { duration: 3000 })
  }

  ArchivalNotification(archive: boolean): any {
    this.snackBar.open(`Case ${archive ? 'archived' : 'unarchived'} successfully!`, 'close', { duration: 3000 })
  }

  dashboardHelper(respCases: Array<any>): Observable<Array<any>> {
    var tempData = [];
    // tslint:disable-next-line:forin
    for (let item in respCases) {
      let caseItem: any;
      caseItem = respCases[item];
      if (caseItem.DrugsInSystem) {
        let DrugInSystemArray = caseItem.DrugsInSystem;
        // console.log(caseItem.DrugsInSystem);
      }

      let documents: InterviewDocument[];
      let hasFiles: boolean = false;
      if (caseItem.Data["FamilyInterviewDocuments"]) {
        documents = JSON.parse(caseItem.Data["FamilyInterviewDocuments"]);
        hasFiles = (documents && documents.length > 0);
      }

      tempData.push({
        id: caseItem.id,
        OCME: caseItem.OCME,
        IsArchived: caseItem.IsArchived,
        ResidentJurisdiction: caseItem.Data['ResidentJurisdiction'],
        DateofDeath: caseItem.Data['DateofDeath'],
        DateofIncident: caseItem.Data['DateofIncident'],
        CauseofDeath: caseItem.Data['CauseofDeath'],
        CountyofDeath: caseItem.Data['CountyofDeath'],
        IsNonFatal: caseItem.Data['IsNonFatal'] || false,
        HasFiles: hasFiles,
        IsAssignedCaseOverDue: caseItem.IsAssignedCaseOverDue || false,
        Flagged: caseItem.Flagged,
        Status: caseItem.Status,
        DrugInSystem: caseItem.DrugInSystem
      });
    }
    return of(tempData);
  }

  dashBoardOpenCasesResponse(resp: CaseByPageModel): void {
    this.currentOpenCaseCount = resp.Count;
    this.openCaseOverDueCount = resp.OverDueCount;
    this.OpenObserve = this.dashboardHelper(resp.Cases);
  }

  dashBoardAvailableCasesResponse(resp: CaseByPageModel): void {
    this.currentAvailableCaseCount = resp.Count;
    this.avaliableCaseOverDueCount = resp.OverDueCount;
    this.AvailableObserve = this.dashboardHelper(resp.Cases);
  }

  dashBoardDismissedCasesResponse(resp: CaseByPageModel): void {
    this.currentDismissedCaseCount = resp.Count;
    this.dismissedCaseOverDueCount = resp.OverDueCount;
    this.DismissedObserve = this.dashboardHelper(resp.Cases);
  }

  dashBoardSubmittedCasesResponse(resp: CaseByPageModel): void {
    this.currentSubmittedCaseCount = resp.Count;
    this.submittedCaseOverDueCount = resp.OverDueCount;
    this.SubmittedObserve = this.dashboardHelper(resp.Cases);
  }

  getPastDueBadgeText(count: number) {
    let cntText;
    if (count > 100) cntText = "100+";
    else cntText = count.toString();

    return cntText;
  }

  setCaseArchival(caseId: string, status: string, archive: boolean): void {
    this.status = 'loading';
    let shouldUpdate = confirm(`Do you want to ${archive ? 'archive' : 'unarchive'} this case?`);

    if (shouldUpdate) {
      this.caseService.setArchivalStatus(caseId, archive).then(res => {
        status = status.toUpperCase();
        switch(status) {
          case 'DISMISSED':
            this.paginationDismissedData();
            break;
          case 'SUBMITTED':
            this.paginationSubmittedData();
            break;
          case 'ASSIGNED':
            this.paginationOpenCasesData();
            break;
          case 'AVAILABLE':
            this.paginationAvailableCasesData();
            break;
        }

        this.ArchivalNotification(archive);
        this.status = 'active';
      }).catch(err => {
        console.error(err);
        this.status = 'active';
      });
    }
  }

  updateCaseStatus(caseId: string, oldStatus: string, newStatus: string): void {
    this.status = 'loading';
    let shouldUpdate = true;

    if (
      newStatus.toUpperCase() == 'ASSIGNED' &&
      (oldStatus.toUpperCase() == 'AVAILABLE' || oldStatus.toUpperCase() == 'DISMISSED')
    ) {
      // tslint:disable-next-line:max-line-length
      shouldUpdate = confirm(`I acknowledge that this case has been selected for case review at a Local Overdose Fatality Review Team meeting. I certify that my request for prescription monitoring data (PDMP Data) is for the purpose of furthering an existing, bona fide, individual case review. I certify that the Local Overdose Fatality Review Team reviewing this case has met the requirements to be eligible to request PDMP Data. I understand and agree to comply with the statutory and regulatory requirements for Local Overdose Fatality Review Team access to and use of prescription monitoring data enumerated in Health General Article, Section 21-2A, Annotated Code of Maryland, and Code of Maryland Regulations (COMAR) 10.47.07.\n\n Health General Article § 21-2A-06, Annotated Code of Maryland, states that PDMP data are confidential and privileged, are not subject to discovery, subpoena or other means of legal compulsion in civil litigation, are not public records, and except as explicitly allowed within statute may not be disclosed to any person. PDMP Data is subject to additional standards beyond other protected health information (PHI), and Local Overdose Fatality Review Teams should take appropriate measures to ensure its security and prevent any re-disclosure. Re-disclosure of PDMP Data by any member of a Local Overdose Fatality Review Team is not allowed outside the membership of the Team for the purposes of case review conducted under the Team’s authority. All Team members and other individuals granted access to confidential or privileged information will be required to sign the Local Overdose Fatality Review Team’s Confidentiality Agreement, which will be kept on file by the Team coordinator and program staff at MDH. No review of confidential or privileged information shall occur without all attendees having signed the Confidentiality Agreement.`)
    }

    if (shouldUpdate) {
      this.caseService.updateCaseStatus(caseId, newStatus).then(res => {
        if (oldStatus.toUpperCase() === 'DISMISSED' || newStatus.toUpperCase() === 'DISMISSED') { this.paginationDismissedData(); }
        if (oldStatus.toUpperCase() === 'SUBMITTED' || newStatus.toUpperCase() === 'SUBMITTED') { this.paginationSubmittedData(); }
        if (oldStatus.toUpperCase() === 'ASSIGNED' || newStatus.toUpperCase() === 'ASSIGNED') { this.paginationOpenCasesData(); }
        if (oldStatus.toUpperCase() === 'AVAILABLE' || newStatus.toUpperCase() === 'AVAILABLE') { this.paginationAvailableCasesData(); }

        this.StatusChangeNotification();
      });
    }

    this.status = 'active';
  }

  paginationOpenCasesData(page: number | null = null): void {
    if (page) this.uiStateService.dashboardUI.OpenCasesPageNum = page;

    this.loading.open = true;;
    let filter = this.getCaseFilter(this.uiStateService.dashboardUI.OpenCasesPageNum);
    filter.size = this.pageSizeOpen;
    this.caseService
      .getOpenCases(filter)
      .then(d => {
        this.dashBoardOpenCasesResponse(d);
        this.loading.open = false;

      })
      .catch(error => { this.loading.open = false; });
  }

  paginationAvailableCasesData(page: number | null = null): void {
    if (page) this.uiStateService.dashboardUI.AvailableCasesPageNum = page;

    this.loading.available = true;
    let filter = this.getCaseFilter(this.uiStateService.dashboardUI.AvailableCasesPageNum);
    filter.size = this.pageSizeAvailable;
    this.caseService
      .getAvailableCases(filter)
      .then(d => {
        this.dashBoardAvailableCasesResponse(d);
        this.loading.available = false;
      })
      .catch(error => { this.loading.available = false; });
  }

  paginationDismissedData(page: number | null = null): void {
    if (page) this.uiStateService.dashboardUI.DismissedCasesPageNum = page;

    this.loading.dismissed = true;
    let filter = this.getCaseFilter(this.uiStateService.dashboardUI.DismissedCasesPageNum);
    filter.size = this.pageSizeDismissed;
    this.caseService
      .getDismissedCases(filter)
      .then(d => {
        this.dashBoardDismissedCasesResponse(d);
        this.loading.dismissed = false;
      })
      .catch(error => { this.loading.dismissed = false; });
  }

  paginationSubmittedData(page: number | null = null): void {
    if (page) this.uiStateService.dashboardUI.SubmittedCasesPageNum = page;

    this.loading.submitted = true;
    let filter = this.getCaseFilter(this.uiStateService.dashboardUI.SubmittedCasesPageNum);
    filter.size = this.pageSizeSubmitted;
    this.caseService
      .getSubmittedCases(filter)
      .then(d => {
        this.dashBoardSubmittedCasesResponse(d);
        this.loading.submitted = false;
      })
      .catch(error => { this.loading.submitted = false; });
  }

  displaySearchCaseProperties(searchCase: SearchCase) {
    let formatted = '';
    for (let key in searchCase) {
      if (searchCase[key] && key in this.searchFieldToName) {
        if (key == 'dateOfDeathFrom' || key == 'dateOfDeathTo' || key == 'dateOfBirthFrom' || key == 'dateOfBirthTo') {
          const date = new Date(searchCase[key]);
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const year = date.getFullYear();
          const formattedDate = `${month}/${day}/${year}`;
          formatted = formatted + this.searchFieldToName[key] + ': ' + formattedDate + ',  ';
        }
        else {
          formatted = formatted + this.searchFieldToName[key] + ': ' + searchCase[key] + ',  ';
        }
      }
    }
    for (let key in searchCase) {
      if (key == 'sortByProperty') {
        formatted = formatted + "Sorted By: " + this.columnToName[searchCase[key]] + ',  ';
      }
    }
    return formatted.replace(/,\s*$/, ''); // remove last comma
  }

  private getCaseFilter(page: number): CaseFilter {
    const searchCase = this.uiStateService.dashboardUI.SearchCase;

    let filter: CaseFilter = <CaseFilter>JSON.parse(JSON.stringify(searchCase));
    filter.page = page;
    filter.size = this.pageSizeOpen;
    filter.isNonFatal = ((searchCase.Fatal && searchCase.NonFatal) || (!searchCase.Fatal && !searchCase.NonFatal)) ?
      null :
      ((searchCase.NonFatal) ? true : false);
    return filter;
  }
}